const { useMemo } = require('react');
const { useStickyProps } = require('hooks/useFormPrimitives');
const FormConfig = require('./formConfig');

const internals = {};

internals.STICKY_PROP_NAMES = [
    'rolePermissions',
    'role',
    'isCompany',
    'isCommunity',
    'isSchoolOnline',
    'includePreferences',
    'preferencesFieldsToShow',
    'preferencesHeadersToShow',
    'hideJobAlerts',
    'showPronounsTextField',
    'majors',
    'incomingClassList',
    'graduatingClassList',
    'departments',
    'officesList',
    'yearsHiredList',
    'transfers',
    'onCampusHousingList',
    'offCampusHousingList'
];

internals.sortTransferOptions = (transfers) => {

    if (!Array.isArray(transfers)) {
        return transfers;
    }

    return transfers.slice().sort((transferA = {}, transferB = {}) => String(transferA.name || '').localeCompare(
        String(transferB.name || ''),
        undefined,
        {
            sensitivity: 'base'
        }
    ));
};

internals.normalizeStableProps = (props = {}) => ({
    ...props,
    transfers: internals.sortTransferOptions(props.transfers)
});

internals.buildStableProps = (options = {}) => useStickyProps.internals.buildStableProps({
    ...options,
    normalizeProps: internals.normalizeStableProps,
    stickyPropNames: internals.STICKY_PROP_NAMES
});

module.exports = function useUserInputsFormConfig(props) {

    const stableProps = useStickyProps(props, {
        normalizeProps: internals.normalizeStableProps,
        stickyPropNames: internals.STICKY_PROP_NAMES
    });

    return useMemo(() => FormConfig.buildConfig({
        props: stableProps
    }), [stableProps]);
};

module.exports.internals = internals;
